var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('ul',{staticClass:"links"},_vm._l((_vm.links),function(link){return _c('li',{key:link.tag,staticClass:"link"},[_c('a',{attrs:{"href":link.route}},[_vm._v(_vm._s(link.tag))])])}),0),_c('p',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }